var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Multiselect',{attrs:{"options":_vm.options,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":"Pick some option","preselect-first":false},on:{"input":_vm.onSelect},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})
}
var staticRenderFns = []

export { render, staticRenderFns }